module.exports = __webpack_public_path__ + "static/img/home_icon3.afd9cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_icon3.png
// module id = 580
// module chunks = 4 5